
import _ from "underscore";
import templateUrl from 'servicestack/file-import/file-imports.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import ServiceBus from "servicestack/service-bus";
import csvParser from 'webutils/services/csv-json';
import modals from 'webmodals/modals';
import 'servicestack/file-import/file-imports.client.scss'
import exceptionsPrompt from 'servicestack/file-import/file-import-exceptions'

class FileImportsController {
    constructor($rootScope) { 
        let $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.bus.send('QueryFileTemplates.json').then(function (response) {
			$ctrl.templates = response.data.results;
			$ctrl.templates.forEach(function (obj) {
				obj.columns = JSON.parse(obj.template);
				obj.headers = obj.columns.map(c => c.title).join(',');
			});
		});
    }
	$onInit() {
		const $ctrl = this;
	}
	selectTemplate(template) {
		const $ctrl = this;
		$ctrl.template = template;
		$ctrl.records = [];
	}
	processText(text, file) {
		let $ctrl = this;
		$ctrl.finished = false;
		$ctrl.records = [];
		$ctrl.records = csvParser.parse(text);
		$ctrl.finished = false;
		resolve('$rootScope').$apply();
	}
	import() {
		let $ctrl = this;
		if ($ctrl.template && $ctrl.records.length > 0) {
			var request = {
				items: [],
				append: $ctrl.template.append
			};
			$ctrl.records.map(record => {
				var item = {};
				item.tags = {};
				$ctrl.template.columns.map((col) => item[col.id] = record[col.title]);
				Object.keys(record).forEach((key) => {
					if (key.indexOf("TAG_") == 0) {
						item.tags[key.replace("TAG_","")] = record[key].replace("|",",");
					}
				});
				request.items.push(item);
			});
			$ctrl.bus.send($ctrl.template.apiCall, request).then(function (response) {
				if ($ctrl.template.apiCall == "ImportProspects" && response.data.exceptions && response.data.exceptions.length) {
					exceptionsPrompt.open({ exceptions: response.data.exceptions, title: 'Import completed with exceptions' });
				} else {
					modals.alert("Data import completed successfully");
				}
			});
		}
	}
}

let FileImports = {
    bindings: {
    },
    controller: FileImportsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default FileImports